import React from 'react';
import { BlockBody } from '@tradingblock/components';
import { TabOptions, BlockType } from '@tradingblock/types';
import { ActivityContent } from '././ActivityContent';
import { PositionSync } from '../shared/PositionSync';
import { Block } from '../../components/blocks/Block';
import { getBlockProps } from '../../utilities/block';
import { BlockTabWell } from '../../components/blocks/BlockTabWell';
import { useActivitySettings } from './useActivitySettings';

const ActivityTabs: TabOptions[] = [
  { title: 'Trades', active: true },
  { title: 'Orders' },
  { title: 'Messages' },
  { title: 'Summary' },
];

export const ActivityBlock: React.FunctionComponent<{}> = () => {
  const { current, definitions } = useActivitySettings();
  return (
    <Block
      {...getBlockProps(BlockType.Activity, <BlockTabWell />, ActivityTabs)}
      settings={current}
      settingFields={definitions}
    >
      <BlockBody className={'block-body'}>
        <PositionSync />
        <ActivityContent />
      </BlockBody>
    </Block>
  );
};
